// extracted by mini-css-extract-plugin
module.exports = {"scroll-black":"number-of-views_scroll-black__A9OWS","container":"number-of-views_container__QbkgO"};